<template>
  <v-card>
    <v-card-title>{{transaction.amount | price(transaction.currency)}}</v-card-title>
    <v-card-text>
      <div>
        {{transaction.at | simpleDate}}. {{transaction.org_notes}}
      </div>

      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container grid-list-xl fluid>
          <v-layout wrap>
            <v-flex xs12 sm3>
              <v-autocomplete
                v-model="transaction.account.key"
                :loading="accountLoading"
                :items="accounts"
                label="Account"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm3>
              <v-autocomplete
                v-model="transaction.category.key"
                :loading="categoryLoading"
                :items="categories"
                label="Category"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                v-model="transaction.narration"
                :rules="[v => !!v || 'Narration is required']"
                label="Narration" 
                required></v-text-field>
            </v-flex>


            <v-flex xs12 sm12>
              <v-autocomplete
                v-model="transaction.tags"
                :loading="tagLoading"
                :items="tags"
                multiple
                chips
                clearable
                label="Tags"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm12>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                v-model="transaction.notes"
                label="Notes" 
                ></v-text-field>
            </v-flex>

          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <loading-state text="" :state="state"></loading-state>
      <v-btn color="blue darken-1" text v-show="!state.isLoading()" @click="$emit('input', false)">Cancel</v-btn>
      <v-btn :disabled="(!valid) || state.isLoading()" color="success" class="mr-4" @click="validate"
      >
      Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import moment from 'moment'
import Utils from "@/utils"
import { DataState } from "@/state"
import { Account } from "@/models/account"
import { Category } from "@/models/category"
import { Tag } from "@/models/tag"
import { Transaction } from "@/models/transaction"
export default {
  props: {
    transaction: {
      default: ()=>{return Transaction.newEmpty()},
      type: Object
    }
  },
  data: () => ({
    dateFormat: 'YYYY-M-D',
    timeFormat: 'HH:mm',
    dateFormatted: '',
    state: DataState.newNotInit(),
    accountLoading: false,
    accounts: [],
    categoryLoading: false,
    categories: [],
    tagLoading: false,
    tags: [],
    datemenu: false,
    valid: true,
    lazy: true,
  }),
  watch: {
    'transaction.date' (val) {
      this.dateFormatted = this.formatDate(this.transaction.date)
    }
  },
  mounted () {

    this.onLoaded()
  },
  methods: {
    onLoaded () {
      if(this.transaction.date) {
        this.dateFormatted = this.formatDate(this.transaction.date)
      }

      this.accountLoading = true
      Account.list().then((response) => {
        this.accounts = response.map((r) => {
          return { text: r.name, value: r.key }
        })
        this.accountLoading = false
        this.categoryLoading = true
        return Category.list()
      }).then((response) => {
        this.categories = response.map((r) => {
          return { text: r.name, value: r.key }
        })
        this.categoryLoading = false
        this.tagLoading = true
        return Tag.list()
      }).then((response) => {
        this.tags = response.map((r) => {
          return { text: r.name, value: r.name }
        })
        this.tagLoading = false
      }).catch((error) => {
        console.log('Err', error)
      })
    },

    validate () {
      if (this.$refs.form.validate()) {
        if(this.transaction.key) {
          this.saveTransaction(false)
        } else {
          this.saveTransaction(true)
        }
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    formatDate (date) {
      return moment(date, this.dateFormat).format(this.dateFormat)
    },

    parseDate (date) {
      let newDate = date
      if (!newDate) {
        newDate = this.transaction.date
      }
      return moment(newDate, this.dateFormat).format(this.dateFormat)
    },

    saveTransaction (create) {
      this.valid = false
      this.state.changeToLoading()
      let fn = 'create'
      if (!create) {
        fn = 'save'
      }
      this.transaction[fn]().then((response) => {
        // this.transaction = Transaction.newEmpty()
        this.state.changeToLoaded()
        if(create) {
          this.$emit('created', response)
        } else {
          this.$emit('saved', response)
        }
        // this.$refs.form.reset()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },
  },
}
</script>